import helpers from "../../../_helpers/helpersFunction";


export default {
    tryCharge,
    checkTrustPayPayment,
    checkTransactionStatus,
    creaIntento
}



async function tryCharge(dati){
    var token = localStorage.getItem('token');
    try{
  
      return await fetch(process.env.REACT_APP_PAY+"/orders/trustpay/tryCharge",{ 
        method: 'post', 
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ token
        },
        body: JSON.stringify(dati)
      })
      .then(res => res.json())
      .then(response => {
        return response
      })
      .catch((err)=>{
        helpers.logToBackend("tryCharge 1",{clickid:dati.clickid,error:err.message})
      })
    }catch(err){
        helpers.logToBackend("tryCharge try catch",{clickid:dati.clickid,error:err.message})
    }
  }


/* ------- controlla il pagamento per il flusso client di TrustPay con POPUP */
async function checkTrustPayPayment(dati){
    return await fetch(process.env.REACT_APP_PAY+"/orders/trustpay/checkPayment",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch((err)=>{
        helpers.logToBackend("Paypal Error 1",{clickid:dati.clickid,error:err.message})
    })
  }



/* ------- controlla il pagamento per il flusso S2S di TrustPay dopo il redirect con 3DS */
async function checkTransactionStatus(dati){
    return await fetch(process.env.REACT_APP_PAY+"/orders/trustpay/checkTransactionStatus",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch((err)=>{
        helpers.logToBackend("Paypal Error 1",{clickid:dati.clickid,error:err.message})
    })
  }



  async function creaIntento(dati){
    var token = localStorage.getItem('token');
    try{
  
      return await fetch(process.env.REACT_APP_PAY+"/orders/trustpay/intent",{ 
        method: 'post', 
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ token
        },
        body: JSON.stringify(dati)
      })
      .then(res => res.json())
      .then(response => {
        return response
      })
      .catch((err)=>{
        helpers.logToBackend("tryCharge 1",{clickid:dati.clickid,error:err.message})
      })
    }catch(err){
        helpers.logToBackend("tryCharge try catch",{clickid:dati.clickid,error:err.message})
    }
  }